import { Controller } from "@hotwired/stimulus"

// Submit-button loading UI. Never disable the button on click — on Hotwire Native
// WKWebView that races with form submission and cancels the POST (stuck "Procesando…").
// Disable only after Turbo has started the request (turbo:submit-start).
export default class extends Controller {
  static targets = ["spinner", "icon"]

  connect() {
    const labelElement = this.element.querySelector("[data-button-label]")
    this.originalLabel = labelElement ? labelElement.textContent : ""

    this.form = this.element.closest("form")
    if (!this.form) return

    this.submitStartBound = this.handleSubmitStart.bind(this)
    this.submitEndBound = this.resetLoading.bind(this)
    this.submitBound = this.handleSubmit.bind(this)

    this.form.addEventListener("turbo:submit-start", this.submitStartBound)
    this.form.addEventListener("turbo:submit-end", this.submitEndBound)
    this.form.addEventListener("submit", this.submitBound, true)
  }

  disconnect() {
    if (!this.form) return

    this.form.removeEventListener("turbo:submit-start", this.submitStartBound)
    this.form.removeEventListener("turbo:submit-end", this.submitEndBound)
    this.form.removeEventListener("submit", this.submitBound, true)
  }

  setLoading(event) {
    const button = this.element
    if (!button || !this.form) return
    if (!this.form.checkValidity()) return

    this.applyLoadingVisuals(button)
  }

  handleSubmitStart() {
    const button = this.element
    if (!button) return

    this.applyLoadingVisuals(button)
    button.disabled = true
  }

  handleSubmit(event) {
    // HTML5 validation blocked submit after click painted loading state.
    if (this.form && !this.form.checkValidity()) {
      setTimeout(() => this.resetLoading(), 0)
    }
  }

  applyLoadingVisuals(button) {
    if (!this.originalLabel) {
      const labelElement = button.querySelector("[data-button-label]")
      this.originalLabel = labelElement ? labelElement.textContent : ""
    }

    button.classList.add("opacity-50", "cursor-wait", "pointer-events-none")

    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove("hidden")
    }

    if (this.hasIconTarget) {
      this.iconTarget.classList.add("hidden")
    }

    const labelElement = button.querySelector("[data-button-label]")
    const loadingLabel = button.dataset.loadingLabel || "Cargando..."
    if (labelElement) {
      labelElement.textContent = loadingLabel
    }
  }

  resetLoading() {
    const button = this.element
    if (!button) return

    button.classList.remove("opacity-50", "cursor-wait", "pointer-events-none")

    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("hidden")
    }

    if (this.hasIconTarget) {
      this.iconTarget.classList.remove("hidden")
    }

    const labelElement = button.querySelector("[data-button-label]")
    if (labelElement && this.originalLabel) {
      labelElement.textContent = this.originalLabel
    }

    button.disabled = false
  }
}
